import React, { useState } from "react";
import { addJob } from "../../services/Api";
import { useAuth } from "../../services/AuthContext";
import PopupWrapper from "../../components/PopupWrapper";
import { useToast } from '../../services/ToastContext';
import { useRefresh } from "../../services/RefreshContext";

const AddJobsForm = ({ isOpen, onClose }) => {
  // const [childID, setChildID] = useState("");
  const { familyID } = useAuth();
  const { showToast } = useToast();
  const { triggerRefresh } = useRefresh();

  const [jobName, setJobName] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const [inputErrors, setInputErrors] = useState({
    inputJobName: "",
    inputPaymentAmount: "",
  });

  // Validation function
  const validateAddJobForm = () => {
    let valid = true;
    const newErrors = {
      inputJobName: "",
      inputPaymentAmount: "",
    };

    if (!jobName.trim()) {
      newErrors.inputJobName = "Job name is required";
      valid = false;
    }

    if (!paymentAmount || isNaN(paymentAmount) || parseFloat(paymentAmount) <= 0) {
      newErrors.inputPaymentAmount = "Enter a valid job payment amount greater than 0";
      valid = false;
    }

    setInputErrors(newErrors);
    return valid;
  };

  const handleCancelButton = async (e) => {
    e.preventDefault();
    onClose();
  };

  const handleAddJob = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!validateAddJobForm()) {
      setIsLoading(false);
      return;
    }

    try {
      await addJob(jobName, paymentAmount, familyID);

      // Reset form fields
      setJobName("");
      setPaymentAmount("");
      // setAlreadySubmitted(true);

      triggerRefresh();
      showToast("Job Added");
      onClose();
    } catch (error) {
      setError(error.message || "An error occurred while adding the job.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PopupWrapper
        isOpen={isOpen}
        onClose={onClose}
        title="Add Jobs"
      >
        <form className="user m-1">
          <div className="form-group">
            <input
              type="text"
              className="form-control form-control-user"
              id="jobNameInputAddJob"
              placeholder="Job Name..."
              onChange={(e) => setJobName(e.target.value)}
              value={jobName}
            />
            {inputErrors.inputJobName && (
              <p className="text-danger">{inputErrors.inputJobName}</p>
            )}
          </div>
          <div className="form-group">
            <input
              type="number"
              className="form-control form-control-user"
              id="exampleInputAmount"
              placeholder="Enter Payment Amount"
              min="0"
              step="0.01"
              onChange={(e) => setPaymentAmount(e.target.value)}
              value={paymentAmount}
            />
            {inputErrors.inputPaymentAmount && (
              <p className="text-danger">
                {inputErrors.inputPaymentAmount}
              </p>
            )}
          </div>
          <br></br>
          {error && <p className="text-danger">{error}</p>}

          <div className="popupButtons">
            <button
              type="button"
              className="cancel-btn p-3 grey-color"
              onClick={handleCancelButton}
            >
              Cancel
            </button>

            <button
              type="submit"
              className={`confirm-btn p-3${isLoading ? " opacity-50 cursor-not-allowed" : ""}`}
              disabled={isLoading}
              onClick={handleAddJob}
            >
              {isLoading ? "Adding Job..." : "Add Job"}
            </button>
          </div>
        </form>
      </PopupWrapper>
    </>
  );
};

export default AddJobsForm;
